import { Autocomplete, Box, FormControl, TextField } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import type { ConnectionCategory } from "../../moment/hooks/use-connections";
import type { MomentFormMoment } from "../../moment/types/moment-form-moment";

export const ConnectionSelectController: FC<{
  connectionCategories: ConnectionCategory[];
}> = ({ connectionCategories }) => {
  const { control } = useFormContext<MomentFormMoment>();

  return (
    <Controller
      control={control}
      name="target_connection_type"
      render={({ field }) => (
        <FormControl fullWidth>
          <Autocomplete
            id="connection-select"
            value={connectionCategories.find(({ key }) => key === field.value) || null}
            options={connectionCategories}
            renderOption={(renderProps, option) => (
              <Box component="li" {...renderProps} key={option.key}>
                {option.display_name}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                label="Connection"
                placeholder="Connection"
                variant="standard"
                {...params}
                slotProps={{
                  input: { ...params.InputProps, "data-testid": "connection-select" },
                }}
              />
            )}
            getOptionLabel={(option) => option.display_name}
            onChange={(_, connectionCategory) => {
              if (!connectionCategory) return;
              field.onChange(connectionCategory.key);
            }}
          />
        </FormControl>
      )}
    />
  );
};
